// src/components/store/sections/gallery/GalleryV3CarouselStripRose.tsx
"use client";

import React from "react";
import DynamicGalleryVariant from "./DynamicGalleryVariant";

export default function GalleryV3CarouselStripRose(props: any) {
  return (
    <DynamicGalleryVariant
      variantNumber={3}
      archKey="carousel_strip"
      archLabel="Marquee Strip"
      palName="CrimsonRose"
      grad="from-rose-500 via-pink-600 to-red-600"
      lightBg="bg-rose-50"
      textCol="text-rose-700"
      borderCol="border-rose-200"
      btnCls="bg-rose-600 hover:bg-rose-700"
      hexCol="#f43f5e"
      {...props}
    />
  );
}
